import Moment from "moment";
const CompanyChartCoinAbout = props => {
  const { overview } = props;
  return (
    <div className="event-page-company-chart-section">
      <div className="event-page-company-chart-section-title">About</div>
      <div className="event-page-company-chart-section-row">
        {overview?.symbol ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Symbol
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {overview?.symbol}
            </div>
          </div>
        ) : null}
        {overview?.category ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Category
            </div>
            <div className="event-page-company-chart-section-row-item-text text-capitalize">
              {overview?.category}
            </div>
          </div>
        ) : null}

        {overview?.date_launched ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Launch Date
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {Moment(overview?.date_launched).format(" DD MMM YYYY")}
            </div>
          </div>
        ) : null}

        {overview?.website ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Website
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              <a
                href={overview?.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-link text-primary"
              >
                {overview?.website}
              </a>
            </div>
          </div>
        ) : null}
        {overview?.explorer ? (
          <div className="event-page-company-chart-section-row-item event-page-company-chart-section-row-item-full">
            <div className="event-page-company-chart-section-row-item-label">
              Explorer
            </div>
            <div className="event-page-company-chart-section-row-item-text ">
              {overview?.explorer?.map((a, index) => {
                return (
                  <div key={index}>
                    <a
                      href={a}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-link text-primary"
                    >
                      {a}
                    </a>{" "}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}

        {overview?.description ? (
          <div className="event-page-company-chart-section-row-item event-page-company-chart-section-row-item-full">
            <div className="event-page-company-chart-section-row-item-text">
              {overview?.description}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CompanyChartCoinAbout;
